import { Component, OnInit } from '@angular/core';
import {Router, ActivatedRoute} from  '@angular/router';
import { ConnectRestService } from 'src/app/services/connect-rest.service';
import {FormBuilder, FormGroup, FormArray, Validators} from '@angular/forms';
import * as $ from 'jquery';
import { EnglishTranslation, MalayTranslation, ProductCode } from '../app.constants';

@Component({
  selector: 'app-business-banking-service',
  templateUrl: './business-banking-service.component.html',
  styleUrls: ['./business-banking-service.component.scss']
})
export class BusinessBankingServiceComponent implements OnInit {

  constructor(public router: Router,private connect : ConnectRestService,private formBuilder:FormBuilder,
    private activatedRoute: ActivatedRoute) { }
  BankingServiceOnLoad = true;
  ResponseBody: any;
  ServiceBody: FormGroup;
  InitialLoad = true;  
  DuitNow : Boolean;
  IsOneCollectSelected : string;
  BusinessDebitCards: boolean = true;
  datavalue : Boolean;
  isEditMode: boolean = false;
  isEditCard: boolean = false;
  product: string;
  checked: Boolean=true;
  RefDWDL: any;
  RefPPDL: any;
  CardDetailList: any;
  selPPDL: any = ['RM 1,000','RM 1,000'];
  selDWDL: any = ['RM 1,000','RM 1,000'];
  contaclessPurchase: any = [false, false];
  onlinePurchase: any = [false, false];
  cardNeedAttention: number = 0;
  activeCards: any = [];
  noOfSelectedCards: number = 0;
  actions: any = ['edit', 'remove', 'add', 'okay'];
  dataa:any[]=[];
  pb:any[]=[];
  prefferedOCBCBranch: string;
  currentProduct: string = ProductCode.eBiz;
  textContent: any;
  showEAlertReceiver: boolean = false;
  eAlertMode: any = [
    {
      Mode: 'By SMS',
      Value: 'SMS'
    },
    {
      Mode: 'By email',
      Value: 'EM'
    },
    {
      Mode: 'By SMS and email',
      Value: 'Both'
    }
  ];
  EAlertThreshold: any = [
    {
      Name: 'RM10,000 & above', // /  / RM50,000 & above / RM100,000 & above
      Value: '10'
    },
    {
      Name: 'RM25,000 & above',
      Value: '25'
    },
    {
      Name: 'RM50,000 & above',
      Value: '50'
    },
    {
      Name: 'RM100,000 & above',
      Value: '100'
    }
  ];
  ProductCode: any = ProductCode;
    

  ngOnInit() {
    this.currentProduct = sessionStorage.getItem('currentProduct') ? sessionStorage.getItem('currentProduct') : this.currentProduct;
    var langTranslation = sessionStorage.getItem("language");
    this.textContent = langTranslation == 'en-us' || langTranslation == undefined ? EnglishTranslation.BusinessBankingServiceScreen : MalayTranslation.BusinessBankingServiceScreen;
    //var data = {DuitNow:['']} 
    this.isEditMode = this.activatedRoute.snapshot.paramMap.get('edit') === 'true' ? true : false;

    this.RefDWDL = JSON.parse(sessionStorage.RefDWDL);
    this.RefPPDL = JSON.parse(sessionStorage.RefPPDL);

    this.ServiceBody = this.formBuilder.group({
      DuitNow:[''],
      IsOneCollect:[''],
      BusinessDebitCards: [''],
      BranchLocation:['', Validators.required],
      PreferredBranch:['', Validators.required],
      EAlertMode:['', Validators.required],
      EAlertThreshold: ['', Validators.required],
      EAlertReceiver1: ['', Validators.required],
      EAlertReceiver2: ['', Validators.required],
      CardDetails0: this.formBuilder.group({
        CardholderName: ['', Validators.required],
        CompanyName: [''],
        DWDL: [''],
        PPDL:[''],
        ContactlesPurchase: [''],
        OnlinePurchases: ['']
      }),
      CardDetails1: this.formBuilder.group({
        CardholderName: ['', Validators.required],
        CompanyName: [''],
        DWDL: [''],
        PPDL:[''],
        ContactlesPurchase: [''],
        OnlinePurchases: ['']
      })
    });
    
    this.restConnect({});
  
  }  
  
  onSubmit(){
    this.InitialLoad = false;
    if(this.ServiceBody.value.DuitNow){
      this.datavalue = true;
    }else{
      this.datavalue = false;
    }
    if(this.ServiceBody.value.IsOneCollectSelected == 'Yes'){
      this.datavalue = true;
    }else{
      this.datavalue = false;
    }
    if(this.ServiceBody.value.IsOneCollect == true){
      this.IsOneCollectSelected = 'Yes';
    }else{
      this.IsOneCollectSelected = 'No';
    }
    sessionStorage.setItem('IsOneCollectSelected', this.IsOneCollectSelected)
    
    var data = {
    //sDuitNow: this.datavalue
     "BusinessBankingServices": {
        "BasicCurrentAccount": true, 
        "InternetBanking": true,
        "DuitNow": $('#DuitNow').is(':checked'),
        "IsOneCollectSelected": this.IsOneCollectSelected,
        "IsBusinessDebitCard" : this.BusinessDebitCards,
        "BusinessLocation": this.ServiceBody.value.BranchLocation,
        "PreferredOCBCBranch": this.ServiceBody.value.PreferredBranch
      },
      "CardDetailList": []
    }
    if(this.BusinessDebitCards)
    this.CardDetailList.forEach((card, key) => {
      data.CardDetailList.push({
        "IsSelected": this.activeCards[key],
        "CompanyName": this.ServiceBody.get(['CardDetails' + key, 'CompanyName']).value,
        "DisplayName": this.ServiceBody.get(['CardDetails' + key, 'CardholderName']).value,
        "ID": card.ID,
        "CardholderName": this.ServiceBody.get(['CardDetails' + key, 'CardholderName']).value,
        "ATMDailyWithdrawal": this.selDWDL[key],
        "DailyPurchaseAndPayment":  this.selPPDL[key],
        "IsContactlessPurchase" : this.contaclessPurchase[key],
        "IsOnlineTransaction" : this.onlinePurchase[key],
      })
    });
    if (this.currentProduct === ProductCode.Access || this.currentProduct === ProductCode.Signature) {
      var EAlerReceiverData = [];
      if (this.showEAlertReceiver) {
        if (this.ServiceBody.value.EAlertReceiver1) {
          EAlerReceiverData.push({ 
            EAlertReceiverName: this.CardDetailList[0].DisplayName, 
            EAlertReceiverNRIC: this.CardDetailList[0].DisplayNRIC
          });
        }
        if (this.ServiceBody.value.EAlertReceiver2) {
          EAlerReceiverData.push({ 
            EAlertReceiverName: this.CardDetailList[1].DisplayName, 
            EAlertReceiverNRIC: this.CardDetailList[1].DisplayNRIC
          });
        }
      } else {
        EAlerReceiverData.push({ 
          EAlertReceiverName: this.CardDetailList[0].DisplayName, 
          EAlertReceiverNRIC: this.CardDetailList[0].DisplayNRIC
        });
      }
      data.BusinessBankingServices["EAlertMode"] = this.ServiceBody.value.EAlertMode;
      data.BusinessBankingServices["EAlertReceiver"]  = EAlerReceiverData;
      data.BusinessBankingServices["EAlertThreshold"] = this.ServiceBody.value.EAlertThreshold;
    }
    this.restConnect(data);
  }

  async restConnect(data){
  
    if(this.InitialLoad){
      var RequestID = "R0060"
    }else{
      var RequestID = "S0060"
    }    
    var responseData = await this.connect.connectRest(data,RequestID,'')
    var locStorage=JSON.parse(localStorage.getItem("URLParam"))
    this.product=locStorage.ProductDescription
    if(responseData.Status == "Success"){
      if (!this.InitialLoad){
        if (!this.isEditMode) {
          // this.router.navigate(['//upload-document']);
       // From Jira GCBAA 15048 sprint 15
       // start
       // this.router.navigate(['//upload-nric']);
          this.router.navigate(['/signature']);
      // end   
        } else {
          this.router.navigate(['/declaration', {edit:true}]);
        }
      } else {
        this.ResponseBody = responseData;
        this.DuitNow = this.ResponseBody.BusinessBankingServices.DuitNow;
        this.IsOneCollectSelected = this.ResponseBody.BusinessBankingServices.IsOneCollectSelected;
        this.BusinessDebitCards = this.currentProduct == this.ProductCode.eBiz || this.currentProduct == this.ProductCode.eBizi ? this.currentProduct == this.ProductCode.eBiz || this.currentProduct == this.ProductCode.eBizi: this.ResponseBody.BusinessBankingServices.IsBusinessDebitCard;
        this.CardDetailList = this.ResponseBody.CardDetailList;
        this.ServiceBody.patchValue({
          BranchLocation: this.ResponseBody.BusinessBankingServices.BusinessLocation
        });
        this.ServiceBody.patchValue({
          EAlertMode: this.ResponseBody.BusinessBankingServices.EAlertMode ? this.ResponseBody.BusinessBankingServices.EAlertMode : '',
          EAlertThreshold: this.ResponseBody.BusinessBankingServices.EAlertThreshold ? this.ResponseBody.BusinessBankingServices.EAlertThreshold : '',
          EAlertReceiver1: this.ResponseBody.BusinessBankingServices.EAlertReceiver.length === 0
        });
        this.retrieveBranchCode();
      }
    }else{      
      this.ResponseBody = responseData;
      this.DuitNow = this.ResponseBody.BusinessBankingServices.DuitNow;
      this.IsOneCollectSelected = this.ResponseBody.BusinessBankingServices.IsOneCollectSelected;
      this.CardDetailList = this.ResponseBody.CardDetailList;
    }
    if(this.DuitNow==undefined || this.DuitNow==true){
      $('#DuitNow').prop('checked','checked');
    } 
    if(this.IsOneCollectSelected=="Yes"){
      $('#IsOneCollectSelected').prop('checked','checked')
      this.ServiceBody.patchValue({IsOneCollect: true});
    }  
    if(this.BusinessDebitCards){
      $('#BusinessDebitCards').prop('checked','checked')
      this.ServiceBody.patchValue({BusinessDebitCards: true});
    }
    this.CardDetailList.forEach((card, key) => {
      let name = card.CardholderName ? card.CardholderName : card.DisplayName;
      if(name.length > 19) {
        this.cardNeedAttention++;
        this.onClickButtonLink(key, 'edit');
      }
      this.ServiceBody.get(['CardDetails' + key, 'CardholderName']).setValue(name);
      card.CompanyName = card.CompanyName.slice(0,19)
      this.ServiceBody.get(['CardDetails' + key, 'CompanyName']).setValue(card.CompanyName);
      this.CardDetailList[key].edit = name.length > 19 ? true : false;
      this.onlinePurchase[key] = card.IsOnlineTransaction==undefined || card.IsOnlineTransaction==true;
      this.contaclessPurchase[key] = card.IsContactlessPurchase==undefined || card.IsContactlessPurchase==true;
      this.activeCards.push(this.CardDetailList[key].IsSelected);
      if(this.CardDetailList[key].IsSelected) {
        this.noOfSelectedCards++;
      }
      this.selDWDL[key] = card.ATMDailyWithdrawal ? card.ATMDailyWithdrawal : 'RM 1,000';
      this.selPPDL[key] = card.DailyPurchaseAndPayment ? card.DailyPurchaseAndPayment  : 'RM 1,000';
      this.ServiceBody.get(['CardDetails' + key, 'DWDL']).setValue(this.selDWDL[key]);
      this.ServiceBody.get(['CardDetails' + key, 'PPDL']).setValue(this.selPPDL[key]);
    });
    this.showEAlertReceiver = this.CardDetailList.length > 1 ? true : false;
    if (this.showEAlertReceiver && this.ResponseBody.BusinessBankingServices.EAlertReceiver.length > 0) {
      this.ResponseBody.BusinessBankingServices.EAlertReceiver.forEach(receiver => {
        if (receiver.EAlertReceiverName + receiver.EAlertReceiverNRIC === this.CardDetailList[0].DisplayName + this.CardDetailList[0].DisplayNRIC)  {
          this.ServiceBody.patchValue({
            EAlertReceiver1: true
          });
        }

        if (receiver.EAlertReceiverName + receiver.EAlertReceiverNRIC === this.CardDetailList[1].DisplayName + this.CardDetailList[1].DisplayNRIC)  {
          this.ServiceBody.patchValue({
            EAlertReceiver2: true
          });
        }
      });
    }
  }

  cardCheckBoxChange() {
    this.BusinessDebitCards = $('#BusinessDebitCards').is(':checked');
  }

  onClickButtonLink(index, action) {
    if(action == 'edit') {
      this.CardDetailList[index].edit = !this.CardDetailList[index].edit;
      this.setPurchases(index);
    } else if(action == 'remove') {
      this.activeCards[index] = false;
      this.CardDetailList[index].IsSelected = false;
      this.noOfSelectedCards--;
    } else if(action == 'okay') {
      this.CardDetailList[index].edit = !this.CardDetailList[index].edit;
      this.cardNeedAttention = 0;
      this.CardDetailList.forEach((card, key) => {
        if(this.ServiceBody.get(['CardDetails' + key, 'CardholderName']).value.length > 19) {
          this.cardNeedAttention++;
        }
      });
    } else{
      this.activeCards[index] = true;
      this.CardDetailList[index].IsSelected = true;
      this.CardDetailList[index].DisplayName = '';
      this.CardDetailList[index].edit = true;
      this.ServiceBody.get(['CardDetails' + index, 'CardholderName']).setValue('');
      this.noOfSelectedCards++;
      this.setPurchases(index);
    } 
  }

  setPurchases(index) {
    setTimeout(() => {
      if(this.contaclessPurchase[index]){
        if (index == 0) {
          $('#ContactlessPurchase0').prop('checked','checked');
        } else {
          $('#ContactlessPurchase1').prop('checked','checked');
        }
      }

      if(this.onlinePurchase[index]){
        if (index == 0) {
          $('#OnlinePurchases0').prop('checked','checked');
        } else {
          $('#OnlinePurchases1').prop('checked','checked');
        }
      }
    }, 300);
  }

  getCardholderName(i) {
    return this.ServiceBody.get(['CardDetails' + i, 'CardholderName']).value;
  }

  getEAlertReceiver(i) {
    if (this.CardDetailList)
    return this.CardDetailList[i].DisplayName + ' ' + this.CardDetailList[i].DisplayNRIC;
  }

  nameUpperCase(index, value) {
    this.ServiceBody.get(['CardDetails' + index, 'CardholderName']).setValue(value.toUpperCase());
  }

  checkIfValid(index) {
    return this.ServiceBody.get(['CardDetails' + index, 'CardholderName']).value.length > 19 || this.ServiceBody.get(['CardDetails' + index, 'CardholderName']).value.length == 0;
  }
  
  getNoOfChar(index) {
    return this.ServiceBody.get(['CardDetails' + index, 'CardholderName']).value.length;
  }

  checkNext() {
    let next = false;
    if(this.ServiceBody.controls.BranchLocation.status == 'INVALID' || this.ServiceBody.controls.PreferredBranch.status == 'INVALID') {
      next = true;
    }
    if (this.currentProduct == ProductCode.Access || this.currentProduct == ProductCode.Signature) {
      if(this.ServiceBody.controls.EAlertThreshold.status == 'INVALID' || this.ServiceBody.controls.EAlertMode.status == 'INVALID') {
        next = true;
      }
      if(this.showEAlertReceiver 
        && (this.ServiceBody.controls.EAlertReceiver1.status == 'INVALID' || !this.ServiceBody.value.EAlertReceiver1)
        && (this.ServiceBody.controls.EAlertReceiver2.status == 'INVALID' || !this.ServiceBody.value.EAlertReceiver2)) {
        next = true;
      }
    }
    if(!this.BusinessDebitCards) return next;
    if(this.CardDetailList && this.CardDetailList.length>0)
      this.CardDetailList.forEach(card => {
        if (card.edit && card.IsSelected) {
          next = true;
          return;
        }
      })

    return next;
  }

  DWDLChange(i, value) {
    this.selDWDL[i] = value;
  }

  PPDLChange(i, value) {
    this.selPPDL[i] = value;
  }

  contactlessChange(i) {
    let value = i == 0 ?  $('#ContactlessPurchase0').is(':checked') :  $('#ContactlessPurchase1').is(':checked');
    this.contaclessPurchase[i] = value;
  }

  onlineChange(i) {
    let value = i == 0 ?  $('#OnlinePurchases0').is(':checked') :  $('#OnlinePurchases1').is(':checked');
    this.onlinePurchase[i] = value;
  }

  async retrieveBranchCode (){
    var responseData = await this.connect.connectRest({ Keys:[{Code:"ALL"}], ProductCode: this.currentProduct },"R0500","")
    
    if(responseData.Status == "Success"){
      this.dataa = responseData['LocationList'];
      if(this.ServiceBody.value.BranchLocation) {
        this.setFormData(this.ServiceBody.value.BranchLocation);
        this.ServiceBody.patchValue({
          PreferredBranch: this.ResponseBody.BusinessBankingServices.PreferredOCBCBranch
        });
      }
    }
  
  }
  //(End) CW 23Apr2021
    //(Begin) 23Apr2021 get preferred branch
  public setFormData(bl) {
    var c=this.ServiceBody.get("BranchLocation")

    this.ServiceBody.patchValue({
      PreferredBranch: ''
    });
  
    var v=[]
    //filter preferedBranchList based on the state selected
    v=this.dataa.filter(m=>m.State==bl);
    this.pb=v[0].PreferredBranchList;
  }
}
